import type { ReduxState as State } from '../index';

export const getBooking = ({
  booking,
}: State) => booking;
